var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEmpty || _vm.$ceres.isShopBuilder
    ? _c("div", { staticClass: "widget-inner", style: _vm.styleInner }, [
        _c("div", { class: _vm.classInner, style: _vm.styleChildInner }, [
          _c(
            "ul",
            { class: "list-style-" + _vm.listStyle + " align-" + _vm.align },
            [
              _vm._l(_vm.entries, function(entry, entryIndex) {
                return [
                  entry.entryType == "text"
                    ? [
                        _c(
                          "li",
                          { key: entryIndex, staticClass: "text-type" },
                          [
                            entry.icon != "none"
                              ? _c("i", {
                                  staticClass: "fa",
                                  class: [entry.iconClass],
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            entry.text.length > 0 &&
                            entry.urlVal &&
                            entry.urlVal.length > 0
                              ? _c(
                                  "a",
                                  {
                                    style: { color: _vm.fontColor },
                                    attrs: {
                                      target: entry.url.openInNewTab
                                        ? "blank_"
                                        : false,
                                      rel: entry.url.type ? "noopener" : false,
                                      href: entry.urlVal
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(entry.text) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _c("span", [_vm._v(_vm._s(entry.text))])
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  entry.entryType == "vprop"
                    ? [
                        _vm.$ceres.isShopBuilder
                          ? _c(
                              "li",
                              {
                                key: "entry-" + entryIndex,
                                staticClass: "vprop cast-preview"
                              },
                              [
                                entry.icon != "none"
                                  ? _c("i", {
                                      staticClass: "fa",
                                      class: [entry.iconClass],
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "vprop-name" }, [
                                  _vm._v("Eigenschaft ID")
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(entry.variationPropertyId))
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.listPoints(entry.variationPropertyId),
                          function(point, pointIndex) {
                            return [
                              _c(
                                "li",
                                {
                                  key: "point-" + entryIndex + "-" + pointIndex,
                                  staticClass: "vprop",
                                  class: "cast-" + point.cast
                                },
                                [
                                  entry.iconClass != "none"
                                    ? _c("i", {
                                        staticClass: "fa",
                                        class: entry.iconClass,
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  entry.variationPropertyShowName &&
                                  point.name &&
                                  point.cast !== "file"
                                    ? _c(
                                        "span",
                                        { staticClass: "vprop-name" },
                                        [_vm._v(_vm._s(point.name))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  point.cast === "file"
                                    ? _c("a", {
                                        style: { color: _vm.fontColor },
                                        attrs: {
                                          href: _vm._f("propertyFileUrl")(
                                            point.value
                                          ),
                                          target: "_blank"
                                        },
                                        domProps: {
                                          textContent: _vm._s(
                                            entry.variationPropertyShowName
                                              ? point.name
                                              : point.value
                                          )
                                        }
                                      })
                                    : point.cast === "html"
                                    ? _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(point.value)
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          textContent: _vm._s(point.value)
                                        }
                                      })
                                ]
                              )
                            ]
                          }
                        )
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }